import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  fetchDiseasesAlerts,
  fetchDiseases,
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchDiseases.STARTED]: handleActionStart,
  [fetchDiseasesAlerts.STARTED]: handleActionStart,
  [fetchDiseases.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload.data.diseasesAlerts;
  },
  [fetchDiseasesAlerts.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload.data;
  },
  [fetchDiseases.FAILED]: handleActionError,
  [fetchDiseasesAlerts.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.diseasesAlerts,
  [clearCurrentPatient]: () => initialState,
});
